export const securitySetup = {
  junior: {
    requirements: [
      { name: 'SSH Key Setup', description: 'Generate and configure SSH keys for Git', priority: 'high' },
      { name: 'Two-Factor Authentication', description: 'Enable 2FA on all development accounts', priority: 'high' },
      { name: 'VPN Access', description: 'Install and configure company VPN', priority: 'high' },
      { name: 'Password Manager', description: 'Set up company-approved password manager', priority: 'medium' }
    ],
    procedures: [
      { step: 'Generate SSH key', command: 'ssh-keygen -t ed25519 -C "your.email@company.com"' },
      { step: 'Add SSH key to agent', command: 'ssh-add ~/.ssh/id_ed25519' },
      { step: 'Copy public key', command: 'pbcopy < ~/.ssh/id_ed25519.pub' },
      { step: 'Add to GitHub', description: 'Paste public key in GitHub SSH settings' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Code Signing Certificate', description: 'Obtain code signing certificate for releases', priority: 'high' },
      { name: 'Security Training', description: 'Complete OWASP security training', priority: 'high' },
      { name: 'Vulnerability Scanning', description: 'Set up automated security scans', priority: 'medium' },
      { name: 'Secret Management', description: 'Configure access to secret management system', priority: 'high' }
    ],
    procedures: [
      { step: 'Install security scanner', command: 'npm install --save-dev snyk' },
      { step: 'Run vulnerability audit', command: 'npm audit' },
      { step: 'Configure pre-commit hooks', command: 'npm install --save-dev husky' },
      { step: 'Set up secret scanning', command: 'git secrets --install' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Security Architecture Review', description: 'Lead security architecture reviews', priority: 'high' },
      { name: 'Compliance Certification', description: 'Obtain relevant compliance certifications', priority: 'medium' },
      { name: 'Incident Response Training', description: 'Complete incident response training', priority: 'high' },
      { name: 'Penetration Testing', description: 'Coordinate penetration testing activities', priority: 'medium' }
    ],
    procedures: [
      { step: 'Configure security monitoring', command: 'helm install falco falcosecurity/falco' },
      { step: 'Set up threat detection', command: 'kubectl apply -f security-policies.yaml' },
      { step: 'Enable audit logging', command: 'aws logs create-log-group --log-group-name /aws/apigateway/audit' },
      { step: 'Configure SIEM integration', description: 'Set up security event forwarding to SIEM' }
    ]
  }
};
